import { FunctionComponent } from 'react';
import styles from './VideosSpecifications.module.scss';
import clsx from 'clsx';

interface VideosSpecificationsProps {
    maxVideos: number;
    className?: string;
}

export const VideosSpecifications: FunctionComponent<VideosSpecificationsProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <span className={styles.text}>Recommended Resolution: 1080p MP4</span>
            <span className={styles.text}>{`Max ${props.maxVideos} Videos`}&nbsp;&nbsp; Max Size: 50MB</span>
        </div>
    );
};

export default VideosSpecifications;
